import { ErrorHandler, InjectionToken, isDevMode, } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { RewriteFrames } from '@sentry/integrations';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
export var SENTRY_TRACKED_DOMAINS = new InjectionToken('Sentry Tracked Domains');
export var SENTRY_DSN = new InjectionToken('Sentry DSN');
var SentryErrorHandler = /** @class */ (function () {
    function SentryErrorHandler(_document, dsn, domains) {
        this._isSentryEnabled = false;
        this._handled = false;
        this._beforeBreadcrumb = function (breadcrumb) {
            if (breadcrumb.category === 'xhr') {
                var parts = breadcrumb.data.url.split('?');
                var url = parts[0];
                var info = parts.length > 1 ? '[queryparams]' : '';
                breadcrumb.data.url = "" + url + info;
            }
            return breadcrumb;
        };
        this._isSentryEnabled =
            domains.some(function (domain) {
                return domain.test(_document.location.hostname);
            }) ||
                isDevMode();
        if (!this._isSentryEnabled) {
            return;
        }
        var release = isDevMode() ?
            'DEV' :
            __VERSION__;
        var integrations = isDevMode() ?
            [] :
            [new RewriteFrames()];
        Sentry.init({
            dsn: dsn,
            release: release,
            beforeBreadcrumb: this._beforeBreadcrumb,
            integrations: integrations,
        });
    }
    SentryErrorHandler.prototype.handleError = function (error) {
        if (!this._isSentryEnabled || this._handled) {
            return;
        }
        Sentry.captureException(error);
        this._handled = true;
    };
    SentryErrorHandler.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SentryErrorHandler_Factory() { return new SentryErrorHandler(i0.ɵɵinject(i1.DOCUMENT), i0.ɵɵinject(SENTRY_DSN), i0.ɵɵinject(SENTRY_TRACKED_DOMAINS)); }, token: SentryErrorHandler, providedIn: "root" });
    return SentryErrorHandler;
}());
export { SentryErrorHandler };
